import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Pipe({
  name: 'stringSanitizer',
  standalone: false,
})
export class StringSanitizerPipe implements PipeTransform {
  public constructor(private sanitizer: DomSanitizer) {}

  public transform(base64string: string | SafeUrl): SafeUrl {
    let result: SafeUrl = null;
    if (base64string && base64string.constructor.name !== 'SafeUrlImpl') {
      result = this.sanitizer.bypassSecurityTrustUrl(base64string as string);
    }
    return result;
  }
}
